import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=33029979&"
import script from "./branches.vue?vue&type=script&lang=js&"
export * from "./branches.vue?vue&type=script&lang=js&"
import style0 from "./branches.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports